/*
|--------------------------------------------------------------------------
| Utilities: Ad Block
|--------------------------------------------------------------------------
*/
/**
 * Lazy Ads
 * @namespace
 */
  //<----- RYAN EDIT
__gh__webApp.utilities.adblock = {
	"checkBlock": function(){
		debug.log("checkBlock")
		var blockingValue = (typeof(defslot_a) === "undefined") ? true : false;	
		
		return blockingValue;
	},
	"checkBlockGPT": function(){
		debug.log("checkBlock DFP")
		var blockingValue = (typeof(defslot_a) === "undefined") ? true : false;	
		
		if(typeof(googletag.cmd.push(function() {})) == "undefined"){
			debug.log('GPT library did not load')
				
			blockingValue=true;
		}

		return blockingValue;
	},
	"checkBlockAmazonH": function(){
		debug.log("checkBlock Amazon")
		var blockingValue = (typeof(defslot_a) === "undefined") ? true : false;	
		
		if(typeof(amznads.setTargetingForGPTAsync) == "undefined"){
			debug.log('amazon script did not load')
				
			blockingValue=true;
		}

		
		return blockingValue;
	},
	"checkHidden": function(checkID){
		debug.log("checkHidden")
		var checkID = (typeof checkID !== 'undefined') ?  checkID : 'dfp-ad-leaderboard',
		myElem = document.getElementById(checkID),
		hidingValue = false;

		if (myElem === null) {
			debug.warn("Warning: Element with ID= "+checkID+" does not exsist. Can't check if hidden")
		}
		else{
			hidingValue=$("#"+checkID+"").is(":hidden") //need to check if this ad is actually called
			debug.log("hidingValue= "+hidingValue)
		}
		
		return hidingValue;
		
	}
};
